import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper';
import GLightbox from "glightbox";
import lottie from 'lottie-web';
import lottieData from '../../images/k-food-Pv02.json';

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });

    // INIT SWIPER
    const sliders = document.querySelectorAll('.swiper');
    sliders.forEach(function (slider) {
        const autoSwiper = slider.classList.contains('swiper--auto');
        const swiper = new Swiper(slider, {
            // configure Swiper to use modules
            modules: [Pagination, Navigation, Autoplay, EffectFade],
            effect: 'slide',
            fadeEffect: {
                crossFade: true
            },
            direction: 'horizontal',
            loop: true,
            slidesPerView: 3,

            autoplay: autoSwiper ? {
                delay: 5000,
            } : false,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    });

    // FIXED HEADER
    window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop > 30 || document.body.scrollTop > 30){
            document.body.classList.add('menu--fixed');
        } else {
            document.body.classList.remove('menu--fixed');
        }
    });



    //Communicate with Unity
    const unityCanvas = document.querySelector("#unity-canvas");
    const hashFormDiv = document.querySelector("#hash-form");
    const loadingDiv = document.querySelector("#loading");
    const gameDiv = document.querySelector("#game");
    const sectionInner = document.querySelector(".section_inner");

    if (unityCanvas) {

        const offsetHeightGame = gameDiv.offsetHeight;
        const offsetHeightHashForm = hashFormDiv.offsetHeight;

        sectionInner.style.height = offsetHeightHashForm + 'px';

        const loginButton = document.querySelector('.btn-login');

        // Disable the login button initially
        loginButton.disabled = true;

        // Add event listeners to the form fields
        const formFields = document.querySelectorAll('input[type="text"], input[type="email"], input[type="checkbox"]');
        formFields.forEach(field => {
            field.addEventListener("input", (e) => {
                checkFields();
            });
            field.addEventListener("change", (event) => {
                checkFields();
            })
        });

        //Check in Cookies for the player Hash
        let playerHash = document.cookie.split('; ').find(row => row.startsWith('playerHash='));
        playerHash && (playerHash = playerHash.split('=')[1]); // Extract the value from the cookie
        console.log('Player hash:', playerHash);
        if (playerHash) {
            hashFormDiv.style.opacity = '0';
            hashFormDiv.style.pointerEvents = 'none';
            gameDiv.style.opacity = '1';
            gameDiv.style.pointerEvents = 'all';

            //First create the Unity instance
            createUnityInstance(unityCanvas, {
                arguments: [],
                dataUrl: "game/Build/game.data",
                frameworkUrl: "game/Build/game.framework.js",
                codeUrl: "game/Build/game.wasm",
                streamingAssetsUrl: "game/StreamingAssets",
                companyName: "Adiwidjaja Teamworks",
                productName: "K-Food Clawgame",
                productVersion: "1.0",
                matchWebGLToCanvasSize: true, // Uncomment this to separately control WebGL canvas render size and DOM element size.
                // devicePixelRatio: 1, // Uncomment this to override low DPI rendering on high DPI displays.
            }).then((unityInstance) => {
                window.unityInstance = unityInstance;

                // Send the player hash to Unity
                unityInstance.SendMessage('HashReceiver', 'ReceiveHash', playerHash);

                //Get the current domain and send it to unity
                const currentDomain = window.location.hostname;
                console.log('Current domain:', currentDomain);
                unityInstance.SendMessage('HashReceiver', 'ReceiveURL', currentDomain);

                sectionInner.style.height = offsetHeightGame + 'px';

                //Launch the game with all required parameters
                unityInstance.SendMessage('StartManager', 'LaunchGame');
            }).catch((message) => {
                alert(message);
            });
        } else {
            // if no one is found, show the form and hide the canvas
            hashFormDiv.style.opacity = '1';
            hashFormDiv.style.pointerEvents = 'all';
            gameDiv.style.opacity = '0';
            gameDiv.style.pointerEvents = 'none';

            //First create the Unity instance
            createUnityInstance(unityCanvas, {
                arguments: [],
                dataUrl: "game/Build/game.data",
                frameworkUrl: "game/Build/game.framework.js",
                codeUrl: "game/Build/game.wasm",
                streamingAssetsUrl: "game/StreamingAssets",
                companyName: "Adiwidjaja Teamworks",
                productName: "K-Food Clawgame",
                productVersion: "1.0",
                matchWebGLToCanvasSize: true, // Uncomment this to separately control WebGL canvas render size and DOM element size.
                // devicePixelRatio: 1, // Uncomment this to override low DPI rendering on high DPI displays.
            }).then((unityInstance) => {
                window.unityInstance = unityInstance;
                //Launch the game with all required parameters
                unityInstance.SendMessage('StartManager', 'LaunchGame');
            }).catch((message) => {
                alert(message);
            });
        }



        function checkFields() {
            const form = document.querySelector('#hash-form');
            const firstname = form.firstname.value;
            const lastname = form.lastname.value;
            const email = form.email.value;
            const age = form.age.checked;
            const privacy = form.privacy.checked;
            const terms = form.terms.checked;

            if (firstname && lastname && email && age && privacy && terms) {
                loginButton.disabled = false;
            } else {
                loginButton.disabled = true;
            }
        }
    }

    const winForm = document.querySelector('#Form_WinForm');
    const submitButton = document.querySelector('#Form_WinForm_action_doWin');

    if (winForm && submitButton) {
        submitButton.disabled = true;

        const formFields = document.querySelectorAll('input[type="text"], input[type="email"]');
        formFields.forEach(field => {
            field.addEventListener("input", () => {
                checkWinFormFields();
            });
            field.addEventListener("change", () => {
                checkWinFormFields();
            });
        });

        function checkWinFormFields() {
            const firstname = winForm.FirstName.value;
            const lastname = winForm.LastName.value;
            const email = winForm.Email.value;
            const address = winForm.Address.value;
            const zipcode = winForm.Zipcode.value;
            const city = winForm.City.value;

            if (firstname && lastname && email && address && zipcode && city) {
                submitButton.disabled = false;
            } else {
                submitButton.disabled = true;
            }
        }
    }

    function showWinForm(winTitle, winDescription, winImageLink)
    {
        console.log("Winning Form");
        console.log(winTitle);
        console.log(winDescription);
        console.log(winImageLink);
    }

    // LOTTIE ANIMATION
    const lottieContainer = document.getElementById('lottie-kfood');
    if (lottieContainer) {
        const BALL_COLORS = {
            blau:    { primary: [0.239, 0,     0.722], secondary: [0.137, 0.447, 0.898] },
            rot:     { primary: [0.890, 0,     0.059], secondary: [1,     0.314, 0.235] },
            gruen:   { primary: [0.294, 0.690, 0.204], secondary: [0,     0.776, 0.169] },
            orange:  { primary: [1,     0.475, 0    ], secondary: [1,     0.773, 0.314] },
            gelb:    { primary: [0.980, 0.820, 0    ], secondary: [1,     0.940, 0.400] },
            pink:    { primary: [0.900, 0.150, 0.550], secondary: [1,     0.500, 0.750] },
            tuerkis: { primary: [0,     0.710, 0.780], secondary: [0.300, 0.900, 0.940] },
        };
        const colorKeys = Object.keys(BALL_COLORS);

        function buildAnimData(colorKey) {
            const key = (colorKey && BALL_COLORS[colorKey]) ? colorKey : colorKeys[Math.floor(Math.random() * colorKeys.length)];
            const { primary: pr, secondary: sc } = BALL_COLORS[key];
            const p = [...pr, 1], s = [...sc, 1];
            const d = JSON.parse(JSON.stringify(lottieData));
            // Keep original color until frame 86 (ball arrives at bottom), then switch
            const origP = d.layers[21].shapes[1].it[1].c.k.slice();
            const origS = d.layers[21].shapes[2].it[1].c.k.slice();
            d.layers[21].shapes[1].it[1].c = { a: 1, k: [{ t: 0, s: origP, h: 1 }, { t: 66, s: p, h: 1 }] };
            d.layers[21].shapes[2].it[1].c = { a: 1, k: [{ t: 0, s: origS, h: 1 }, { t: 66, s: s, h: 1 }] };
            d.layers[0].shapes[0].it[1].c.k = p;
            d.layers[0].shapes[1].it[1].c.k = s;
            return d;
        }

        let anim = lottie.loadAnimation({
            container:     lottieContainer,
            renderer:      'svg',
            loop:          false,
            autoplay:      false,
            animationData: buildAnimData(),
        });

        const hint          = document.getElementById('lottie-hint');
        const regModal      = document.getElementById('lottie-modal-reg');
        const prizeModal    = document.getElementById('lottie-modal-prize');
        const regForm       = document.getElementById('lottie-reg-form');
        const regLoading    = document.getElementById('lottie-loading');
        const formError     = document.getElementById('lottie-form-error');
        const submitBtn     = document.getElementById('lottie-submit-btn');
        const overlay       = document.getElementById('lottie-overlay');
        const participateBtn = document.getElementById('lottie-participate-btn');

        function hideOverlay() {
            if (overlay) overlay.classList.add('hidden');
        }

        // Hide overlay only if registration data is already stored
        const initSaved = JSON.parse(localStorage.getItem('kfood_reg') || 'null');
        if (initSaved && initSaved.firstName) hideOverlay();

        if (participateBtn) {
            participateBtn.addEventListener('click', openRegModal);
        }

        function checkRegForm() {
            const fn   = regForm.querySelector('[name="FirstName"]').value.trim();
            const ln   = regForm.querySelector('[name="LastName"]').value.trim();
            const em   = regForm.querySelector('[name="Email"]').value.trim();
            const age  = regForm.querySelector('[name="AgeVerified"]').checked;
            const priv = regForm.querySelector('[name="PrivacyAccepted"]').checked;
            const trm  = regForm.querySelector('[name="TermsAccepted"]').checked;
            submitBtn.disabled = !(fn && ln && em && age && priv && trm);
        }
        regForm.querySelectorAll('input').forEach(i => {
            i.addEventListener('input', checkRegForm);
            i.addEventListener('change', checkRegForm);
        });

        function openRegModal() {
            // Pre-fill any partially saved contact data
            const saved = JSON.parse(localStorage.getItem('kfood_reg') || 'null');
            if (saved) {
                const fn = regForm.querySelector('[name="FirstName"]');
                const ln = regForm.querySelector('[name="LastName"]');
                const em = regForm.querySelector('[name="Email"]');
                if (fn && !fn.value) fn.value = saved.firstName || '';
                if (ln && !ln.value) ln.value = saved.lastName  || '';
                if (em && !em.value) em.value = saved.email     || '';
                checkRegForm();
            }
            regModal.classList.add('active');
            if (hint) hint.classList.add('hidden');
        }
        function closeRegModal() {
            regModal.classList.remove('active');
            regForm.style.display = '';
            regLoading.hidden = true;
            formError.hidden  = true;
        }

        async function preparePrize(fd, autoStart = false) {
            const res   = await fetch('/main/playgame', { method: 'POST', body: fd });
            const prize = await res.json();
            if (!prize.Success) throw new Error(prize.Error || 'Fehler beim Laden des Gewinns.');

            if (prize.PrizeImage) {
                const preload = new Image();
                preload.src = prize.PrizeImage;
            }

            anim.destroy();
            anim = lottie.loadAnimation({
                container:     lottieContainer,
                renderer:      'svg',
                loop:          false,
                autoplay:      false,
                animationData: buildAnimData(prize.BallColor),
            });
            let prizeShown = false;
            anim.addEventListener('enterFrame', (e) => {
                if (!prizeShown && e.currentTime >= 185) {
                    prizeShown = true;
                    showPrizeModal(prize);
                }
            });

            pendingPrize = prize;

            if (autoStart) {
                lottieContainer.removeEventListener('click', handleContainerClick);
                if (hint) hint.classList.add('hidden');
                anim.goToAndPlay(0, true);
            } else {
                if (hint) {
                    hint.textContent = 'Klicken zum Starten!';
                    hint.classList.remove('hidden');
                }
            }
        }

        let pendingPrize = null;

        function handleContainerClick() {
            if (pendingPrize) {
                lottieContainer.removeEventListener('click', handleContainerClick);
                if (hint) hint.classList.add('hidden');
                anim.goToAndPlay(0, true);
                return;
            }

            const saved = JSON.parse(localStorage.getItem('kfood_reg') || 'null');
            if (saved && saved.firstName && saved.lastName && saved.email) {
                // Data already known – skip the form and fetch the prize directly
                if (hint) hint.textContent = 'Wird geladen…';
                const fd = new FormData();
                fd.set('FirstName',       saved.firstName);
                fd.set('LastName',        saved.lastName);
                fd.set('Email',           saved.email);
                fd.set('AgeVerified',     'True');
                fd.set('PrivacyAccepted', 'True');
                fd.set('TermsAccepted',   'True');
                preparePrize(fd, true).catch(() => {
                    if (hint) hint.textContent = 'Klicken zum Mitspielen';
                });
            } else {
                openRegModal();
            }
        }

        lottieContainer.addEventListener('click', handleContainerClick);
        if (hint) hint.addEventListener('click', handleContainerClick);

        document.getElementById('lottie-modal-reg-close').addEventListener('click', () => {
            closeRegModal();
            if (hint) hint.classList.remove('hidden');
        });
        regModal.addEventListener('click', (e) => {
            if (e.target === regModal) { closeRegModal(); if (hint) hint.classList.remove('hidden'); }
        });

        function closePrizeModal() {
            prizeModal.classList.remove('active');
            pendingPrize = null;
            anim.goToAndStop(0, true);
            lottieContainer.addEventListener('click', handleContainerClick);
            if (hint) {
                hint.textContent = 'Klicken zum Mitspielen';
                hint.classList.remove('hidden');
            }
        }

        document.getElementById('lottie-modal-prize-close').addEventListener('click', closePrizeModal);
        prizeModal.addEventListener('click', (e) => {
            if (e.target === prizeModal) closePrizeModal();
        });

        regForm.addEventListener('submit', async (e) => {
            e.preventDefault();
            regForm.style.display = 'none';
            regLoading.hidden = false;
            formError.hidden  = true;

            const fd = new FormData(regForm);
            fd.set('AgeVerified',     regForm.querySelector('[name="AgeVerified"]').checked     ? 'True' : 'False');
            fd.set('PrivacyAccepted', regForm.querySelector('[name="PrivacyAccepted"]').checked ? 'True' : 'False');
            fd.set('TermsAccepted',   regForm.querySelector('[name="TermsAccepted"]').checked   ? 'True' : 'False');

            try {
                await preparePrize(fd);

                localStorage.setItem('kfood_reg', JSON.stringify({
                    firstName: regForm.querySelector('[name="FirstName"]').value.trim(),
                    lastName:  regForm.querySelector('[name="LastName"]').value.trim(),
                    email:     regForm.querySelector('[name="Email"]').value.trim(),
                }));

                closeRegModal();
                hideOverlay();
            } catch (err) {
                regLoading.hidden = true;
                regForm.style.display = '';
                formError.textContent = err.message;
                formError.hidden = false;
            }
        });

        function showPrizeModal(prize) {
            const img     = document.getElementById('prize-modal-image');
            const title   = document.getElementById('prize-modal-title');
            const actions = document.getElementById('prize-modal-actions');

            img.src    = prize.PrizeImage || '';
            img.hidden = !prize.PrizeImage;
            title.textContent = prize.PrizeTitle       || '';

            actions.innerHTML = '';
            if (!prize.RequiresAddress && prize.PrizeLink) {
                const a = document.createElement('a');
                a.href      = '/' + prize.PrizeLink;
                a.textContent = 'Gewinn herunterladen';
                a.className = 'link--button';
                a.target    = '_blank';
                actions.appendChild(a);
            } else if (prize.RequiresAddress && prize.Hash) {
                const a = document.createElement('a');
                a.href      = '/win?user=' + prize.Hash;
                a.textContent = 'Adresse angeben';
                a.className = 'link--button';
                actions.appendChild(a);
            }

            prizeModal.classList.add('active');
        }
    }
});
